import { ApplicationConfig, provideZoneChangeDetection, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { TranslateModule } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';

import { routes } from './app.routes';
import { loadingInterceptor } from "./interceptors/loading.interceptor";
import { Amplify } from 'aws-amplify';
import { environment } from '../environments/environment';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: environment.userPoolId,
      userPoolClientId: environment.userPoolClientId,
      // The identity pool exchanges the user pool token for temporary, federated
      // AWS credentials, which are used to read and write report images in S3 directly.
      identityPoolId: environment.identityPoolId,
      loginWith: {
        email: true
      }
    }
  },
  Storage: {
    S3: {
      bucket: environment.s3Bucket,
      region: environment.awsRegion
    }
  }
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    importProvidersFrom(
      BrowserAnimationsModule,
      CommonModule,
      TranslateModule.forRoot({
        defaultLanguage: 'en-US',
        // Load the translation files for each language
      })
    ),

    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors([loadingInterceptor])
    ),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    MessageService,
    {
      provide: 'TRANSLATION_CONFIG',
      useValue: {
        defaultLanguage: 'en-US',
        supportedLanguages: ['en-US', 'ru', 'ar']
      }
    }
  ]
};